var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "billboards", style: _vm.customStyle },
    [
      _vm.swipeAuto && _vm.billboardList.length > 0
        ? _c(
            "mt-swipe",
            {
              staticClass: "border-radius-8",
              attrs: { auto: 5000, showIndicators: _vm.showIndicators },
            },
            _vm._l(_vm.billboardList, function (slider) {
              return _c(
                "mt-swipe-item",
                { key: slider.id },
                [
                  slider.actionType !== _vm.ACTIONTYPE_DM
                    ? _c(
                        "router-link",
                        { attrs: { to: slider.href } },
                        [
                          _c("lazy-img", {
                            attrs: {
                              src: slider.imgUrl,
                              alt: "slider",
                              width: "100%",
                              height: "100%",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.bannerClicked(slider.id)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.goToDaMai(slider)
                            },
                          },
                        },
                        [
                          _c("lazy-img", {
                            attrs: {
                              bannerHeight: _vm.bannerHeight,
                              src: slider.imgUrl,
                              alt: "slider",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }